module.exports = __webpack_public_path__ + "static/media/books.6ae87827.svg";